import React, { useState, useEffect } from "react";

export const svg = `<svg width="18" height="18" viewbox="0 0 18 18" fill="currentColors" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.777 6.631c.044.117.107.197.233.357l1.066 1.354a.55.55 0 0 1 .115.368 5.906 5.906 0 0 0 0 .58.55.55 0 0 1-.115.368L2.01 11.012c-.126.16-.19.24-.233.357a.946.946 0 0 0-.049.324c.007.124.036.199.093.348.09.23.218.518.398.83.201.348.398.623.561.829.102.128.153.192.261.262a.95.95 0 0 0 .316.12c.127.02.23.003.436-.032l1.683-.285a.384.384 0 0 1 .279.062c.105.07.212.138.322.202.073.043.11.064.133.08a.569.569 0 0 1 .192.223c.013.026.026.059.053.125l.693 1.732c.082.206.123.308.21.412.063.077.187.176.277.221.12.06.206.074.376.101.266.042.605.077.996.077.436 0 .802-.035 1.083-.077.175-.026.263-.04.387-.102.093-.047.22-.15.285-.23.087-.11.126-.215.205-.427l.644-1.732c.02-.056.031-.084.04-.105a.57.57 0 0 1 .21-.25c.019-.013.05-.031.112-.068.097-.058.193-.119.287-.182a.384.384 0 0 1 .279-.062l1.683.285c.206.035.309.052.436.033a.951.951 0 0 0 .316-.12c.107-.071.158-.135.26-.263.164-.205.36-.481.561-.829.181-.313.31-.6.398-.83.058-.15.086-.224.093-.348a.947.947 0 0 0-.048-.324c-.044-.117-.107-.197-.233-.357l-1.067-1.354a.548.548 0 0 1-.114-.367 5.973 5.973 0 0 0 0-.582.548.548 0 0 1 .114-.367l1.066-1.354c.127-.16.19-.24.234-.357a.947.947 0 0 0 .049-.324 1.028 1.028 0 0 0-.094-.347 5.92 5.92 0 0 0-.398-.83 6.788 6.788 0 0 0-.56-.83c-.103-.128-.154-.192-.261-.262a.952.952 0 0 0-.316-.12c-.127-.02-.23-.003-.436.032l-1.683.285-.026.004a.318.318 0 0 1-.231-.051 5.822 5.822 0 0 0-.31-.197 2.195 2.195 0 0 1-.112-.068.571.571 0 0 1-.208-.25c-.01-.021-.02-.05-.041-.105l-.644-1.732c-.079-.212-.118-.318-.206-.426a1.027 1.027 0 0 0-.284-.23c-.124-.064-.212-.077-.387-.103A7.363 7.363 0 0 0 9.007 1c-.391 0-.73.035-.996.077-.17.027-.256.04-.376.1a1.05 1.05 0 0 0-.278.222c-.086.104-.127.207-.209.412l-.694 1.732c-.026.066-.04.1-.053.125a.568.568 0 0 1-.191.222 1.82 1.82 0 0 1-.133.081 5.83 5.83 0 0 0-.322.202.384.384 0 0 1-.28.062L3.794 3.95c-.206-.035-.309-.052-.436-.033a.952.952 0 0 0-.316.121c-.108.07-.159.134-.26.263-.164.205-.36.48-.562.828-.18.313-.309.6-.398.83-.057.15-.086.224-.093.348a.946.946 0 0 0 .049.324ZM12 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
